// extracted by mini-css-extract-plugin
module.exports = {"headerPlaceholder":"page-esi-wrapper_component_headerPlaceholder__0HEYf","headerContent":"page-esi-wrapper_component_headerContent__rnN0_"};